import { RevenueDeductType } from "@/enums/enums";
import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import { RevenueDeductModel } from "@/model/revenueDeduct/revenueDeductModel";
import service from "../baseHttpService";

class RevenueDeductService {
  DoCreateRevenueDeduct(revenueDeduct: RevenueDeductModel) {
    const _input = {
      merchantId: MerchantId(),
      data: revenueDeduct,
    };
    return service.peakPayrollAPI
      .post("/api/RevenueDeduct/CreateRevenueDeduct", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoUpdateRevenueDeduct(revenueDeduct: RevenueDeductModel) {
    const _input = {
      merchantId: MerchantId(),
      data: revenueDeduct,
    };
    return service.peakPayrollAPI
      .post("/api/RevenueDeduct/UpdateRevenueDeduct", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoUpdateRevenueDeductDeleted(revenueDeductId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: revenueDeductId,
    };
    return service.peakPayrollAPI
      .post("/api/RevenueDeduct/UpdateRevenueDeductDeleted", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoUpdateRevenueDeductArchived(revenueDeductDetail: any) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        revenueDeductId: revenueDeductDetail.id,
        isArchived: revenueDeductDetail.isArchived,
      },
    };
    return service.peakPayrollAPI
      .post("/api/RevenueDeduct/UpdateRevenueDeductArchived", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetRevenueDeductDetail(revenueDeductId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: revenueDeductId,
    };
    return service.peakPayrollAPI
      .post("/api/RevenueDeduct/GetRevenueDeductDetail", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetRevenueDeductList() {
    const _input = {};

    return service.peakPayrollAPI
      .post("/api/RevenueDeduct/GetRevenueDeductList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetRevenueDeductSuggestionCode(revenueDeductType: RevenueDeductType) {
    const _input = {
      merchantId: MerchantId(),
      data: revenueDeductType,
    };
    return service.peakPayrollAPI
      .post("/api/RevenueDeduct/GetRevenueDeductSuggestionCode", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new RevenueDeductService();
